import { request } from "@/api/client";

export type ProfitLossReport = {
  income: number | string
  expense: number | string
  net_profit: number | string
  assets: number | string
  liabilities: number | string
  equity: number | string
}

export type SalesTaxReport = {
  bucket: string
  amount: number | string
}

export type EventsProfitReport = {
  event_id: string
  name?: string | null
  date?: string | null
  city?: string | null
  state?: string | null
  profit: number | string
  revenue: number | string
  expenses: number | string
}

export type ShopifyOverview = {
  payout_net: number | string
  payout_fees: number | string
  orders_total: number | string
  orders_tax: number | string
  orders_discounts: number | string
  orders_by_state: Array<{ region: string; amount: number | string }>
  orders_by_day: Array<{ date: string; amount: number | string }>
}

type RangeFilters = {
  start?: string
  end?: string
}

function buildQuery(params?: Record<string, string | undefined>) {
  const query = new URLSearchParams()
  if (!params) return ''
  Object.entries(params).forEach(([key, value]) => {
    if (typeof value === 'string' && value.trim().length > 0) {
      query.set(key, value)
    }
  })
  return query.toString()
}

export function fetchProfitLoss(params?: RangeFilters & { stream?: string }): Promise<ProfitLossReport> {
  const suffix = buildQuery(params)
  return request(`/reports/pnl${suffix ? `?${suffix}` : ''}`)
}

export function fetchSalesTax(params?: RangeFilters & { group_by?: string }): Promise<SalesTaxReport[]> {
  const suffix = buildQuery(params)
  return request(`/reports/sales-tax${suffix ? `?${suffix}` : ''}`)
}

export function fetchEventProfitability(params?: RangeFilters): Promise<EventsProfitReport[]> {
  const suffix = buildQuery(params)
  return request(`/reports/events/profitability${suffix ? `?${suffix}` : ''}`)
}

export function fetchShopifyOverview(params?: RangeFilters): Promise<ShopifyOverview> {
  const suffix = buildQuery(params)
  return request(`/reports/shopify/overview${suffix ? `?${suffix}` : ''}`)
}
